/* globals L jQuery countryData */
import { countryData } from '../countryData.js'
;(function ($) {
  const map = L.map('map', {
    zoom: 4,
    center: window.mapData.latlng,
    maxZoom: 22,
    gestureHandling: true,
    zoomControl: false
  })

  L.control
    .zoom({
      zoomInText: '<span>zoom in</span>',
      zoomOutText: '<span>zoom out</span>'
    })
    .addTo(map)

  L.geoJson(countryData, {
    style: {
      weight: 0.5,
      opacity: 1,
      color: '#82aa9f',
      fillColor: '#f6f6f6',
      fillOpacity: 1
    }
  }).addTo(map)

  if ('shape' in window.mapData) {
    $.getJSON(window.mapData.shape.data, function (data) {
      L.geoJson(data, {
        style: {
          fillColor: '#E16309',
          color: '#222222',
          fillOpacity: 0.5,
          opacity: 0.6,
          weight: 2
        }
      }).addTo(map)
    })
  }

  map.fitBounds(window.mapData.bounds, { padding: [20, 20] })
})(jQuery)
